// src/components/Logo.jsx
import React, { useState } from 'react';
import MenvioWordmark from '../assets/MENVIO_LOGO_groß.png';
import MenvioMark from '../assets/menvio-logo-mark.png';

export default function Logo({
  variant = 'wordmark',         // 'wordmark' | 'mark'
  size = 'md',                  // 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'
  height,                       // optional: direkte Pixelhöhe (überschreibt size)
  className = '',
  title = 'MENVIO',
  alt = 'MENVIO',
  onClick,
  useTextFallback = true,
}) {
  const [hadError, setHadError] = useState(false);

  const wordmarkHeights = { xs: 16, sm: 22, md: 28, lg: 36, xl: 44, xxl: 64, xxxl: 250 };
  const markSizes       = { xs: 16, sm: 22, md: 28, lg: 36, xl: 44, xxl: 64, xxxl: 250 };

  const resolvedHeight = height ?? (variant === 'mark'
    ? (markSizes[size] ?? markSizes.md)
    : (wordmarkHeights[size] ?? wordmarkHeights.md));

  const isMark = variant === 'mark';
  const src    = isMark ? MenvioMark : MenvioWordmark;

  if (hadError && useTextFallback) {
    return (
      <span
        role="img"
        aria-label="MENVIO"
        title={title}
        onClick={onClick}
        className={className}
        style={{
          display: 'inline-flex',
          alignItems: 'baseline',
          lineHeight: 1,
          fontWeight: 800,
          fontFamily:
            "'Inter', ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial, 'Noto Sans'",
          letterSpacing: '0.14em',
          fontSize: resolvedHeight,
          color: 'currentColor',
          userSelect: 'none',
          whiteSpace: 'nowrap',
          cursor: onClick ? 'pointer' : 'default',
        }}
      >
        <span style={{ display: 'inline-block' }}>M</span>
        <span
          style={{
            display: 'inline-block',
            marginLeft: '-0.02em',
            marginRight: '-0.02em',
            transform: 'translateY(-0.02em)',
          }}
        >
          Ξ
        </span>
        <span style={{ display: 'inline-block' }}>N</span>
        <span style={{ display: 'inline-block' }}>V</span>
        <span style={{ display: 'inline-block' }}>I</span>
        <span style={{ display: 'inline-block' }}>O</span>
      </span>
    );
  }

  const imgStyle = isMark
    ? { height: resolvedHeight, width: resolvedHeight, objectFit: 'contain', display: 'inline-block', verticalAlign: 'middle', borderRadius: 6, cursor: onClick ? 'pointer' : 'default' }
    : { height: resolvedHeight, width: 'auto',        objectFit: 'contain', display: 'inline-block', verticalAlign: 'middle', cursor: onClick ? 'pointer' : 'default' };

  return (
    <img
      src={src}
      alt={alt}
      title={title}
      decoding="async"
      draggable={false}
      onClick={onClick}
      onError={() => setHadError(true)}
      className={className}
      style={imgStyle}
    />
  );
}

